import basicFlow from "./asyncHandler";
import { put, select } from "redux-saga/effects";
import { actions } from "../actions/clientes.actions";
import { authenticatedRequest, destinies } from "../utils/api";
import { routeWatcher } from "./rotas.saga";
import { getRouteArguments } from "../selectors/routes.selectors";
import { getUsuarioLogado } from "../selectors/usuario.selectors";
import { transformFromDate } from "../utils/basic";
import {
  actions as routeActions,
  types as routes,
} from "../actions/rotas.actions";

const tratarCliente = ({ response }) => {
  if (!response?.data) {
    return;
  }

  response.data.cliente = {
    ...response.data.cliente,
    _dataNascimento: response.data.cliente.dataNascimento,
    dataNascimento: transformFromDate(response.data.cliente.dataNascimento),
    _dataCasamento: response.data.cliente.dataCasamento,
    dataCasamento: transformFromDate(response.data.cliente.dataCasamento),
    _nacionalidade: response.data.cliente.nacionalidade,
    nacionalidade: !!response.data.cliente.nacionalidade ? { id: response.data.cliente.nacionalidade } : null,
    _escolaridade: response.data.cliente.escolaridade,
    escolaridade: !!response.data.cliente.escolaridade ? { id: response.data.cliente.escolaridade } : null,
    _perfilRenda: response.data.cliente.perfilRenda,
    perfilRenda: !!response.data.cliente.perfilRenda ? { id: response.data.cliente.perfilRenda } : null,
    _estadoCivil: response.data.cliente.estadoCivil,
    estadoCivil: !!response.data.cliente.estadoCivil ? { id: response.data.cliente.estadoCivil } : null,
    _regimeComunhao: response.data.cliente.regimeComunhao,
    regimeComunhao: !!response.data.cliente.regimeComunhao ? { id: response.data.cliente.regimeComunhao } : null,
    _genero: response.data.cliente.genero,
    genero: !!response.data.cliente.genero ? { id: response.data.cliente.genero } : null,
    _dataExpedicaoDocumentoPessoal: response.data.cliente.dataExpedicaoDocumentoPessoal,
    dataExpedicaoDocumentoPessoal: transformFromDate(
      response.data.cliente.dataExpedicaoDocumentoPessoal
    ),
    _documentoPessoal: response.data.cliente.documentoPessoal,
    documentoPessoal: !!response.data.cliente.documentoPessoal ? { id: response.data.cliente.documentoPessoal } : null,
  };

  if (response.data.cliente.dadosProfissionais) {
    response.data.cliente = {
      ...response.data.cliente,
      dadosProfissionais: {
        ...response.data.cliente.dadosProfissionais,
        _dataAdmissao: response.data.cliente.dadosProfissionais.dataAdmissao,
        dataAdmissao: transformFromDate(response.data.cliente.dadosProfissionais.dataAdmissao),
        _profissao: response.data.cliente.dadosProfissionais.profissao,
        profissao: !!response.data.cliente.dadosProfissionais.profissao
          ? { id: response.data.cliente.dadosProfissionais.profissao }
          : null,
        _ramoAtuacao: response.data.cliente.dadosProfissionais.ramoAtuacao,
        ramoAtuacao: !!response.data.cliente.dadosProfissionais.ramoAtuacao
          ? { id: response.data.cliente.dadosProfissionais.ramoAtuacao }
          : null,
        _segmentoServico: response.data.cliente.dadosProfissionais.segmentoServico,
        segmentoServico: !!response.data.cliente.dadosProfissionais.segmentoServico
          ? { id: response.data.cliente.dadosProfissionais.segmentoServico }
          : null,
        _tipoPensao: response.data.cliente.dadosProfissionais.tipoPensao,
        tipoPensao: !!response.data.cliente.dadosProfissionais.tipoPensao
          ? { id: response.data.cliente.dadosProfissionais.tipoPensao }
          : null,
        _tipoImovelAluguel: response.data.cliente.dadosProfissionais.tipoImovelAluguel,
        tipoImovelAluguel: !!response.data.cliente.dadosProfissionais.tipoImovelAluguel
          ? { id: response.data.cliente.dadosProfissionais.tipoImovelAluguel }
          : null,
      },
    };
  }
  if (response.data.cliente.conjuge) {
    response.data.cliente = {
      ...response.data.cliente,
      conjuge: {
        ...response.data.cliente.conjuge,
        _dataNascimento: response.data.cliente.conjuge.dataNascimento,
        dataNascimento: transformFromDate(response.data.cliente.conjuge.dataNascimento),
        _genero: response.data.cliente.conjuge.genero,
        genero: !!response.data.cliente.conjuge.genero ? { id: response.data.cliente.conjuge.genero } : null,
        _nacionalidade: response.data.cliente.conjuge.nacionalidade,
        nacionalidade: !!response.data.cliente.conjuge.nacionalidade
          ? { id: response.data.cliente.conjuge.nacionalidade }
          : null,
        _dataAdmissao: response.data.cliente.conjuge.dataAdmissao,
        dataAdmissao: transformFromDate(response.data.cliente.conjuge.dataAdmissao),
        _profissao: response.data.cliente.conjuge.profissao,
        profissao: !!response.data.cliente.conjuge.profissao ? { id: response.data.cliente.conjuge.profissao } : null,
        _escolaridade: response.data.cliente.conjuge.escolaridade,
        escolaridade: !!response.data.cliente.conjuge.escolaridade
          ? { id: response.data.cliente.conjuge.escolaridade }
          : null,
        _ramoAtuacao: response.data.cliente.conjuge.ramoAtuacao,
        ramoAtuacao: !!response.data.cliente.conjuge.ramoAtuacao
          ? { id: response.data.cliente.conjuge.ramoAtuacao }
          : null,
        _segmentoServico: response.data.cliente.conjuge.segmentoServico,
        segmentoServico: !!response.data.cliente.conjuge.segmentoServico
          ? { id: response.data.cliente.conjuge.segmentoServico }
          : null,
        _tipoPensao: response.data.cliente.conjuge.tipoPensao,
        tipoPensao: !!response.data.cliente.conjuge.tipoPensao
          ? { id: response.data.cliente.conjuge.tipoPensao }
          : null,
        _tipoImovelAluguel: response.data.cliente.conjuge.tipoImovelAluguel,
        tipoImovelAluguel: !!response.data.cliente.conjuge.tipoImovelAluguel
          ? { id: response.data.cliente.conjuge.tipoImovelAluguel }
          : null,
        _perfilRenda: response.data.cliente.conjuge.perfilRenda,
        perfilRenda: !!response.data.cliente.conjuge.perfilRenda
          ? { id: response.data.cliente.conjuge.perfilRenda }
          : null,
        _qualificacao: response.data.cliente.conjuge.qualificacao,
        qualificacao: !!response.data.cliente.conjuge.qualificacao
          ? { id: response.data.cliente.conjuge.qualificacao }
          : null,
        _dataExpedicaoDocumentoPessoal: response.data.cliente.conjuge.dataExpedicaoDocumentoPessoal,
        dataExpedicaoDocumentoPessoal: transformFromDate(
          response.data.cliente.conjuge.dataExpedicaoDocumentoPessoal
        ),
        _estadoCivil: response.data.cliente.conjuge.estadoCivil,
        estadoCivil: !!response.data.cliente.conjuge.estadoCivil
          ? { id: response.data.cliente.conjuge.estadoCivil }
          : null,
        _documentoPessoal: response.data.cliente.conjuge.documentoPessoal,
        documentoPessoal: !!response.data.cliente.conjuge.documentoPessoal
          ? { id: response.data.cliente.conjuge.documentoPessoal }
          : null,
      },
    };
    if (response.data.cliente.conjuge.contaLiberacao) {
      response.data.cliente = {
        ...response.data.cliente,
        conjuge: {
          ...response.data.cliente.conjuge,
          contaLiberacao: {
            ...response.data.cliente.conjuge.contaLiberacao,
            _tipoConta: response.data.cliente.conjuge.contaLiberacao.tipoConta,
            tipoConta: !!response.data.cliente.conjuge.contaLiberacao.tipoConta
              ? { id: response.data.cliente.conjuge.contaLiberacao.tipoConta }
              : null,
            _bancoConta: response.data.cliente.conjuge.contaLiberacao.bancoConta,
            bancoConta: !!response.data.cliente.conjuge.contaLiberacao.bancoConta
              ? { id: response.data.cliente.conjuge.contaLiberacao.bancoConta }
              : null,
          },
        },
      };
    }
  }
  if (response.data.cliente.endereco) {
    response.data.cliente = {
      ...response.data.cliente,
      endereco: {
        ...response.data.cliente.endereco,
        _tipoResidencia: response.data.cliente.endereco.tipoResidencia,
        tipoResidencia: !!response.data.cliente.endereco.tipoResidencia
          ? { id: response.data.cliente.endereco.tipoResidencia }
          : null,
      },
    };
  }
};

const carregarResumo = basicFlow({
  actionGenerator: actions.carregarResumo,
  transform: (values) => {
    let utf8Bytes = new TextEncoder().encode(values.pesquisa);
    return {
      ...values,
      pesquisa: btoa(String.fromCharCode(...utf8Bytes) ?? ""),
    };
  },
  api: (values) => {
    return authenticatedRequest({
      url: "/resumo",
      isResourceService: true,
      destiny: destinies.CLIENTE,
      queryParams: values,
      method: "get",
    });
  },
});

const listarClientes = basicFlow({
  actionGenerator: actions.listarClientes,
  transform: (values) => {
    let utf8Bytes = new TextEncoder().encode(values.pesquisa);
    return {
      ...values,
      pesquisa: btoa(String.fromCharCode(...utf8Bytes) ?? ""),
    };
  },
  api: (values) => {
    return authenticatedRequest({
      url: "/clientes",
      isResourceService: true,
      destiny: destinies.CLIENTE,
      queryParams: values,
      method: "get",
    });
  },
});

const obterCliente = basicFlow({
  actionGenerator: actions.obterCliente,
  api: ({ id }) => {
    return authenticatedRequest({
      url: `/cliente/${id}`,
      isResourceService: true,
      destiny: destinies.CLIENTE,
      method: "get",
    });
  },
});

const obterInstituicoesFinanceiras = basicFlow({
  actionGenerator: actions.obterInstituicoesFinanceiras,
  api: () => {
    return authenticatedRequest({
      url: "/dominios/instituicoes-financeiras",
      destiny: destinies.CLIENTE,
      method: "get",
    });
  },
});

const downloadDocumento = basicFlow({
  actionGenerator: actions.downloadDocumento,
  api: ({ id }) => {
    return authenticatedRequest({
      url: `/artefato/${id}/pre-signed-url`,
      isResourceService: true,
      destiny: destinies.DOCUMENTO,
      method: "get",
    });
  },
  postSuccess: ({ original: { tipo }, response }) => {
    let a = document.createElement("a");
    a.href = response.data;
    a.target = "_blank";
    a.click();
  },
});

const obterParceiros = basicFlow({
  actionGenerator: actions.obterParceiros,
  api: () => {
    return authenticatedRequest({
      url: "/dominios/parceiros",
      destiny: destinies.PARCEIRO,
      method: "get",
    });
  },
});

const obterProdutos = basicFlow({
  actionGenerator: actions.obterProdutos,
  api: () => {
    return authenticatedRequest({
      url: "/dominios/produtos",
      destiny: destinies.WORKFLOW,
      method: "get",
    });
  },
});

const obterDominios = basicFlow({
  actionGenerator: actions.obterDominios,
  api: () => {
    return authenticatedRequest({
      url: `/cliente/dominios`,
      isResourceService: true,
      destiny: destinies.CLIENTE,
      method: "get",
    });
  },
});

const obterPreenchimento = basicFlow({
  actionGenerator: actions.obterPreenchimento,
  api: ({ id }) => {
    return authenticatedRequest({
      url: `/cliente/${id}/preenchimento`,
      isResourceService: true,
      destiny: destinies.CLIENTE,
      method: "get",
    });
  },
  preSuccess: tratarCliente,
});
const gravarPreenchimento = basicFlow({
  actionGenerator: actions.gravarPreenchimento,
  transform: ({ callback, ...values }) => {
    return values;
  },
  api: (values) => {
    console.log(values)
    return authenticatedRequest({
      url: `/cliente/${values.cliente.id}/preenchimento`,
      isResourceService: true,
      destiny: destinies.CLIENTE,
      method: "put",
      body: values,
    });
  },
  preSuccess: tratarCliente,
  postSuccess: ({ original, response }) => {
    if (original.callback) {
      original.callback(response.data);
    }
  },
});
function* listaClientesRouteWatcher() {
  yield routeWatcher([routes.CLIENTES], function* () {
    const usuario = yield select(getUsuarioLogado);

    if (!!usuario) {
      yield put(actions.obterParceiros.request());
      yield put(actions.obterProdutos.request());
      yield put(actions.obterInstituicoesFinanceiras.request());
    }

    yield put(actions.carregarResumo.request({}));
    yield put(actions.listarClientes.request({ pagina: 0, etapa: "total" }));
  });
}
function* detalhesClienteRouteWatcher() {
  yield routeWatcher([routes.DETALHES_CLIENTE], function* () {
    const payload = yield select(getRouteArguments);
    yield put(actions.obterCliente.request(payload));
    yield put(actions.obterDominios.request());
  });
}
function* preenchimentoOperacaoRouteWatcher() {
  yield routeWatcher([routes.PREENCHIMENTO_CLIENTE], function* () {
    const payload = yield select(getRouteArguments);
    yield put(actions.obterPreenchimento.request(payload));
  });
}

export const sagas = [
  listarClientes.watcher(),
  carregarResumo.watcher(),
  obterCliente.watcher(),
  obterParceiros.watcher(),
  obterInstituicoesFinanceiras.watcher(),
  obterProdutos.watcher(),
  downloadDocumento.watcher(),
  obterDominios.watcher(),
  obterPreenchimento.watcher(),
  gravarPreenchimento.watcher(),
  listaClientesRouteWatcher(),
  detalhesClienteRouteWatcher(),
  preenchimentoOperacaoRouteWatcher(),
];
